import { ButtonLink } from './ButtonLink';
import { CinematicHero } from './CinematicHero';

export function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero__layout section-shell">
        <div className="hero__copy reveal">
          <h1>Turn busywork into a system that runs.</h1>
          <p className="hero__support">I design custom apps, automations, and integrations around the way your business already works—so information moves, routine work completes, and your team stays in control.</p>
          <div className="hero__actions">
            <ButtonLink href="#contact">Start a project</ButtonLink>
          </div>
          <ul className="hero__proof" aria-label="Core capabilities">
            <li>Custom apps</li><li>Automation</li><li>Integrations</li><li>AI assistants</li>
          </ul>
        </div>
        <CinematicHero />
      </div>
    </section>
  );
}
